import useApiHook from './useApiHook';
import { useCallback } from 'react';

export const useOrganizationEnum = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getOrganizationEnum = useCallback(async () => {
    const output = await get('/enums/customers');
    const data = output.data.reduce((accumulator, line) => {
      if (accumulator.indexOf(line.name) === -1) {
        accumulator.push(line.name);
      }
      return accumulator;
    }, []);
    return data.map((line) => {
      return {
        id: `${line}`,
        label: `${line}`,
      };
    });
  }, [get]);

  return { getOrganizationEnum, data, error, loading };
};
